import fetch from 'isomorphic-fetch';
import * as ActionType from './types/CartActionTypes';
import * as NotificationsActions from './NotificationActions';

// TODO: MOVE THIS AND USE FOR ALL REQUESTS!!!!
/*
function handleErrors(response, dispatch) {
  if (!response.ok) {
    return response.json().then((json) => {
      dispatch(NotificationsActions.error({ message: json.errorMessage }));
      const error = new Error(json.errorMessage);
      error.response = json;
      throw error;
    });
  }
  return response.json();
}
*/

function cacheBust() {
  return (new Date()).toString();
}

function requestSize() {
  return {
    type: ActionType.REQUEST_SIZE
  };
}

function receiveSize(response) {
  return {
    type: ActionType.RECEIVE_SIZE,
    payload: response.data.items.length // temporary
  };
}

function requestCart() {
  return {
    type: ActionType.REQUEST_CART
  };
}

function receiveCart(response) {
  return {
    type: ActionType.RECEIVE_CART,
    payload: response.data
  };
}

function addItem2() {
  return {
    type: ActionType.ADD_ITEM
  };
}

function addedItem(json) {
  return {
    type: ActionType.ADDED_ITEM,
    payload: json
  };
}

export function unloadCart() {
  return {
    type: ActionType.UNLOAD_CART
  };
}

export function resetCart() {
  return {
    type: ActionType.RESET_CART
  };
}

// Temporary
export function getCartSize() {
  return (dispatch) => {
    dispatch(requestSize());
    return fetch(`/api/v0/cart?cache=${cacheBust()}`,
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveSize(json)));
  };
}

export function getCart() {
  return (dispatch) => {
    dispatch(requestCart());
    return fetch(`/api/v0/cart?cache=${cacheBust()}`,
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveCart(json)));
  };
}

export function addItem(addItemRequest) {
  return (dispatch) => {
    dispatch(addItem2());
    return fetch('/api/v0/cart/item',
      {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(addItemRequest),
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then((json) => {
        if (json && json.errorMessage) {
          const error = new Error(json.errorMessage);
          error.response = json;
          dispatch(NotificationsActions.error({ message: json.errorMessage }));
          throw error;
        } else {
          dispatch(addedItem(json));
        }
      });
  };
}

export function removeItem(id) {
  return (dispatch) => {
    dispatch(requestCart());
    return fetch(`/api/v0/cart/item/${id}`,
      {
        method: 'DELETE',
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveCart(json)));
  };
}

export function removeItems(itemIds) {
  return (dispatch) => {
    dispatch(requestCart());
    return fetch('/api/v0/cart/remove-items',
      {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ itemIds }),
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveCart(json)));
  };
}

export function updateItemQuantity(id, quantity) {
  return (dispatch) => {
    dispatch(requestCart());
    return fetch(`/api/v0/cart/item/${id}`,
      {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ quantity }),
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then((json) => {
        if (json && json.data.errorMessage) {
          const error = new Error(json.data.errorMessage);
          error.response = json.data;
          dispatch(NotificationsActions.error({ message: json.data.errorMessage }));
          throw error;
        } else {
          dispatch({
            type: ActionType.RECEIVE_CART,
            payload: json.data.cart
          });
        }
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/CartActions.js